import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import { fetchQueryData } from 'hooks/use-gremlin-query'
import { externalIntegrationsQueryKeys } from 'queries/external-integrations/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { IntegrationResponse } from 'context/status-checks/StatusCheckExternalIntegrationsContext'

function fetchStatusChecks({
  queryKey: [endpoint, { teamId }]
}: QueryFunctionContext<
  ReturnType<typeof externalIntegrationsQueryKeys.getStatusCheckIntegrations>
>) {
  const endpointWithParams = getEndpointWithParams(endpoint, { teamId })

  return fetchQueryData<IntegrationResponse>(endpointWithParams, {})
}

export function useGetExternalIntegrationsStatusChecks(
  teamId: string,
  options?: Omit<
    QueryObserverOptions<IntegrationResponse, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<IntegrationResponse, AxiosError>({
    ...options,
    queryKey: externalIntegrationsQueryKeys.getStatusCheckIntegrations({
      teamId
    }),
    queryFn: fetchStatusChecks
  })
}
